/*
import { sleep } from "@/utils";

function audioRecorder(){
    return new Promise(resolve => {
        navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];

            mediaRecorder.addEventListener("dataavailable", event => {
                audioChunks.push(event.data);
            });

            const start = () => {
                mediaRecorder.start();
            };

            const stop = () => {
                return new Promise(resolve => {
                    mediaRecorder.addEventListener("stop", () => {
                        const audioBlob = new Blob(audioChunks);
                        const audioUrl = URL.createObjectURL(audioBlob);
                        const audio = new Audio(audioUrl);

                        resolve(audio);
                    });

                    mediaRecorder.stop();
                });
            };

            resolve({ start, stop });
        });
    });
}

async function isAudioSilent(audioElement) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const audioSource = audioElement.src;
    
    try {
      // Fetch the audio data from the audio element's src
      const response = await fetch(audioSource);
      const arrayBuffer = await response.arrayBuffer();
  
      // Decode the audio data
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
      // Get the audio samples from the first channel
      const channelData = audioBuffer.getChannelData(0);
  
      // Analyze the audio samples for silence (assuming silence is near-zero values)
      const threshold = 0.001;  // Adjust this value as needed
  
      //let biggest = -Infinity;
      //let smallest = Infinity;

      for (let i = 0; i < channelData.length; i++) {
        const data = Math.abs(channelData[i]);

        //if(data > biggest) biggest = data;
        //if(data < smallest) smallest = data;

        if (data > threshold) {
            //console.log({ biggest, smallest });

            return false;
        }
      }

      return true;
    } 
    catch (error) {
      console.error(error);

      return true;
    }
}
*/

async function checkMicrophone(check){
    console.log(`${check.title} Check Started`);

	let reply = { isPassed: false, details: "Not Working!" };
	let microphone = undefined;
	
	try {
        const microphoneId = await localStorageCustom.getItem("ecv-microphoneId");
        if(microphoneId){
            microphone = await navigator.mediaDevices.getUserMedia({ audio: { deviceId: microphoneId } });
        }
        else {
		    microphone = await navigator.mediaDevices.getUserMedia({ audio: true });
        }
		
		if(microphone){
            microphone.getTracks().forEach(t => t.stop());
            /*
            const recorder = await audioRecorder();

            recorder.start();
            await sleep(3 * 1000);
            const audio = await recorder.stop();

            if(await isAudioSilent(audio)){
                reply.details = "Detected.";
            }
            else {
                reply.details = "Detected. Voice detected.";
            }
            */
            reply.details = "Detected.";
            reply.isPassed = true;
		}
		else {
            console.error({ microphone });
			reply.details = "Please check if you have a secured (HTTPS) connection and your microphone is connected and authorized to be used.";
		}
	}
	catch(error){
		console.error(error);
		reply.details = error.message;
	}

    reply.details = `${check.title}: ${reply.details}`;
	return reply;
}

export default checkMicrophone;